import { Injectable, Injector } from '@angular/core';
import { Http, RequestOptions, RequestOptionsArgs, Headers, URLSearchParams } from '@angular/http';
import { AuthHttp } from 'angular2-jwt';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { _throw } from 'rxjs/observable/throw';
import * as JSONH from 'jsonh/js/jsonh';
import { ToastrService } from 'ngx-toastr';

export interface PagingParam {
	pageNumber?: number;
	pageSize?: number;
	rowCount?: number;
}

export interface SuccessResponse<T> {
	data: T;
	rowCount?: number;
	totalCount?: number;
	[prop: string]: any;
}

@Injectable()
export class CommonRequestService {
	private toastr: ToastrService;

	constructor(
		injector: Injector,
		private http: Http,
		private authHttp: AuthHttp
	) {
		setTimeout(() => {
			this.toastr = injector.get(ToastrService);
		});
	}
	handleHttpRsp(rsp): SuccessResponse<any> {
		rsp = rsp.json().payload;
		const result: SuccessResponse<any> = {
			data: null
		};
		for (const prop in rsp) {
			if (prop !== 'type' && prop !== 'content') {
				result[prop] = rsp[prop];
			}
		}
		if (rsp.type === 'jsonh') {
			result.data = JSONH.unpack(rsp.content);
		} else if (rsp.type === 'json') {
			result.data = rsp.content;
		} else {
			result.data = rsp;
		}
		return result;
	}
	handleError(err) {
		console.log(err);
		if (err.status === 400) {
			this.toastr.error(err.json().message);
		} else if (err.status === 500) {
			this.toastr.error(err.json().error.errorDetail);
			console.log(err.json().error.errorMessage);
			console.log(err.json().error.errorDetail);
		}
		return Observable.throw(err);
	}
	requestGet(url: string, options?: RequestOptions, successCallback?, errorCallback?, notAuthenticated?: boolean) {
		const requester = notAuthenticated ? this.http : this.authHttp;
		options = options ? options : new RequestOptions();
		return requester.get(url, options)
		.map(rsp => this.handleHttpRsp(rsp))
		.catch(err => this.handleError(err))
		.subscribe((data: SuccessResponse<any>) => {
			try {
				if (successCallback) {
					successCallback(data);
				}
			} catch (err) {
				if (errorCallback) { errorCallback(err); }
			}
		}, (err) => {
			if (errorCallback) {
				errorCallback(err);
			}
		});

	}
	requestPost(url: string, body, successCallback?, errorCallback?, notAuthenticated?: boolean, options?: RequestOptionsArgs) {
		const requester = notAuthenticated ? this.http : this.authHttp;
		options = options ? options : new RequestOptions();
		return requester.post(url, body, options)
		.map(rsp => this.handleHttpRsp(rsp))
		.catch(err => this.handleError(err))
		.subscribe((data) => {
			if (successCallback) {
				successCallback(data);
			}
		}, (err) => {
			if (errorCallback) {
				errorCallback(err);
			}
		});

	}
	requestPut(url: string, body, successCallback?, errorCallback?, notAuthenticated?: boolean, headers?) {
		const requester = notAuthenticated ? this.http : this.authHttp;
		return requester.put(url, body, {
			headers: headers ? headers : new Headers({'Content-Type': 'application/json'})
		})
		.map(rsp => this.handleHttpRsp(rsp))
		.catch(err => this.handleError(err))
		.subscribe((data) => {
			if (successCallback) {
				successCallback(data);
			}
		}, (err) => {
			if (errorCallback) {
				errorCallback(err);
			}
		});
	}
	requestDelete(url: string, options?, successCallback?, errorCallback?, notAuthenticated?: boolean) {
		const requester = notAuthenticated ? this.http : this.authHttp;
		options = options ? options : {};
		return requester.delete(url, options)
		.map(rsp => this.handleHttpRsp(rsp))
		.catch(err => this.handleError(err))
		.subscribe((data) => {
			if (successCallback) {
				successCallback(data);
			}
		}, (err) => {
			if (errorCallback) {
				errorCallback(err);
			}
		});
	}
	setParamsPaging(params: URLSearchParams, paging: PagingParam) {
		if (paging.pageSize || paging.pageSize === 0) {
			params.set('pageSize', paging.pageSize.toString());
		}
		if (paging.pageNumber || paging.pageNumber === 0) {
			params.set('pageNumber', paging.pageNumber.toString());
		}
		if (paging.rowCount || paging.rowCount === 0) {
			params.set('rowCount', paging.rowCount.toString());
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/common-services/common-request.service.ts